const apiUrl = process.env.REACT_APP_API_LINGVO_SEMANTIC;

// TOPICS

export const fetchTopicsSubTopics = async() => {
    const response = await fetch(`${apiUrl}/topics/with-subtopics/all`, {
        method: 'GET',
    });
    if (!response.ok) throw new Error(`HTTP ошибка: ${response.status}`);
    return response.json();
}

export const deleteTopic = async(topicId) => {
    const response = await fetch(`${apiUrl}/topics/${topicId}`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error(`HTTP ошибка: ${response.status}`);
      return response.json();
} 

export const deleteSubTopic = async(subTopicId) => {
    const response = await fetch(`${apiUrl}/topics/subtopics/${subTopicId}`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error(`HTTP ошибка: ${response.status}`);
      return response.json();
} 

export const addTopic = async (topic_name) => {
  const response = await fetch(`${apiUrl}/topics`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name: topic_name }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при добавлении интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const addSubtopicToTopic = async (topicId, subTopicName) => {
  const response = await fetch(`${apiUrl}/topics/${topicId}/subtopics`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name: subTopicName }),
  });
  if (!response.ok) {
    throw new Error(`Ошибка при добавлении интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
}

export const renameSubtopic = async (subTopicId, subTopicName) => {
  const response = await fetch(`${apiUrl}/topics/subtopics/${subTopicId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name: subTopicName }),
  });
  if (!response.ok) {
    throw new Error(`Ошибка при добавлении интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
}

export const addIndexSubtopic = async (subTopicId, subTopicIndex) => {
  const response = await fetch(`${apiUrl}/topics/subtopics/${subTopicId}/index`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ index: subTopicIndex }),
  });
  if (!response.ok) {
    throw new Error(`Ошибка при добавлении индекса у субтопика: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
}

// Semantics

export const fetchSemantics = async (topic_name, language, spelling, top) => {
  const response = await fetch(`${apiUrl}/lingvo/semantica`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text: topic_name, language:language, spelling: spelling, top:top }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при добавлении интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const fetchSubtopicSemantics = async (sub_topic_id, topic_name, language, spelling, top) => {
  const response = await fetch(`${apiUrl}/lingvo/semantica/${sub_topic_id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text: topic_name, language:language, spelling: spelling, top:top }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при добавлении интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const addTopicSemanticDB = async (topic_id, word, normalize) => {
  const response = await fetch(`${apiUrl}/topics/${topic_id}/semantics`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ word: word, normalize: normalize }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при добавлении новой семантике: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};


export const fetchTopicSemanticsDB = async (topic_name, skip = 0, limit = 10) => {
  const response = await fetch(`${apiUrl}/topic/semantic/${topic_name}?skip=${skip}&limit=${limit}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(`Ошибка при запросе семантики из БД для интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const fetchTopicAllSemanticsDB = async (topic_id) => {
  const response = await fetch(`${apiUrl}/topics/${topic_id}/semantics/all`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(`Ошибка при запросе семантики из БД для интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const fetchSubTopicAllSemanticsDB = async (sub_topic_id) => {
  const response = await fetch(`${apiUrl}/sub-topics/${sub_topic_id}/semantics/all`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(`Ошибка при запросе семантики из БД для суб-интереса: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const addSubTopicSemanticDB = async (sub_topic_id, word, normalize) => {
  const response = await fetch(`${apiUrl}/sub-topics/${sub_topic_id}/semantics`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ word: word, normalize: normalize }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при добавлении новой семантике: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const addSubTopicSemanticDBwords = async (sub_topic_id, words) => {
  const response = await fetch(`${apiUrl}/sub-topics/${sub_topic_id}/semantics/all`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ words: words }),
  });
  if (!response.ok) {
    throw new Error(`Ошибка при добавлении новой семантике: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const addSubTopicSemanticDBwordsWithWeights = async (sub_topic_id, wordsWithWeights) => {
  const response = await fetch(`${apiUrl}/sub-topics/${sub_topic_id}/semantics/with-weights`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ words_with_weights: wordsWithWeights }),
  });
  if (!response.ok) {
    throw new Error(`Ошибка при добавлении семантики с весами: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const updateSemanticWord = (sub_or_topic) => {
  // возвращаем функцию с замкнутым sub_or_topic
  return async (semantic_word_id, weight, word = null) => {
    console.log('updateSemanticWord request');
    const body = {};
    if (weight !== null && weight !== undefined) {
      body.weight = weight;
    }
    if (word !== null && word !== undefined) {
      body.word = word;
    }
    
    const response = await fetch(`${apiUrl}/${sub_or_topic}/semantics/${semantic_word_id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.detail || `Ошибка при обновлении семантики: ${response.status}`;
      throw new Error(errorMessage);
    }
    return response.json();
  };
};

// export const deleteTopicSemanticDB = async(topic_name) => {
//   const response = await fetch(`${apiUrl}/semantic/all/${topic_name}`, {
//       method: 'DELETE',
//     });
//     if (!response.ok) throw new Error(`HTTP ошибка: ${response.status}`);
//     return response.json();
// } 


// export const deleteTopicSemanticWordDB = async(topic_name, semantic_word) => {
//   const response = await fetch(`${apiUrl}/semantic/${topic_name}/${semantic_word}`, {
//       method: 'DELETE',
//     });
//     if (!response.ok) throw new Error(`HTTP ошибка: ${response.status}`);
//     return response.json();
// } 

export const deleteSubTopicSemanticDB = async(sub_topic_id) => {
  const response = await fetch(`${apiUrl}/sub-topics/semantics/${sub_topic_id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error(`HTTP ошибка удаление семантики слова под-интереса: ${response.status}`);
    return response.json();
}

export const deleteTopicSemanticDB = async(topic_id) => {
  const response = await fetch(`${apiUrl}/topics/semantics/${topic_id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error(`HTTP ошибка удаление семантики слова интереса: ${response.status}`);
    return response.json();
}


// Lingvo

export const lingvoAnalyze = async(text, language) => {
    const response = await fetch(`${apiUrl}/lingvo/analyze/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text: text, language: language }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при лингво-анализе: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
}


// Finder

export const findTopicsSubtopics = async(text, language) => {
    const response = await fetch(`${apiUrl}/find/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text: text, language: language }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при поиске топиков и субтопиков: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
}


//  Refuse words
export const fetchRefuseWords = async (sub_topic_id) => {
  const response = await fetch(`${apiUrl}/sub-topics/${sub_topic_id}/refuse-words/all`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  });

  if (!response.ok) {
    throw new Error(`Ошибка при получении игнор слов: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};

export const addRefuseWords = async (sub_topic_id, words) => {
  const response = await fetch(`${apiUrl}/sub-topics/${sub_topic_id}/refuse-words/all`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ words: words }),
  });

  if (!response.ok) {
    throw new Error(`Ошибка при добавлении игнор слов: ${response.status}`);
  }
  return response.json(); // ожидаем, что сервер вернёт созданный объект
};